var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Cars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 50,
    viewBox: "195 80 250 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .greyColor {\n      fill: #eee !important;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.463 187.211C206.547 190.029 216.748 189.795 221.713 189.325C221.713 167.055 238.414 161.958 246.764 162.193C266.806 165.294 270.462 181.573 269.785 189.325H374.053C374.053 180.281 378.86 162.193 398.089 162.193C417.318 162.193 422.351 180.281 422.463 189.325C440.609 192.426 442.888 180.751 441.76 174.525C437.156 154.793 420.884 150.565 413.323 150.917C408.448 150.071 390.528 144.927 382.178 142.46C330.45 94.5389 253.648 117.795 221.713 135.413H208.172C203.026 135.413 201.288 140.111 201.062 142.46V155.498L197 162.193V176.287C197 180.516 202.642 185.331 205.463 187.211Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.733 144.575H297.206L293.482 122.376C278.248 119.909 253.874 132.242 244.733 137.175C237.421 141.121 241.687 143.752 244.733 144.575Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304.654 144.575L301.268 122.376C335.46 119.557 351.71 132.947 360.173 137.175C366.944 140.558 364.349 143.517 362.204 144.575H304.654Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.545 187.563C262.545 197.565 254.78 205.5 245.41 205.5C236.04 205.5 228.275 197.565 228.275 187.563C228.275 177.561 236.04 169.626 245.41 169.626C254.78 169.626 262.545 177.561 262.545 187.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M414.886 187.563C414.886 197.565 407.121 205.5 397.751 205.5C388.381 205.5 380.616 197.565 380.616 187.563C380.616 177.561 388.381 169.626 397.751 169.626C407.121 169.626 414.886 177.561 414.886 187.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205.463 304.211C206.547 307.029 216.748 306.795 221.713 306.325C221.713 284.055 238.414 278.958 246.764 279.193C266.806 282.294 270.462 298.573 269.785 306.325H374.053C374.053 297.281 378.86 279.193 398.089 279.193C417.318 279.193 422.351 297.281 422.463 306.325C440.609 309.426 442.888 297.751 441.76 291.525C437.156 271.793 420.884 267.565 413.323 267.917C408.448 267.071 390.528 261.927 382.178 259.46C330.45 211.539 253.648 234.795 221.713 252.413H208.172C203.026 252.413 201.288 257.111 201.062 259.46V272.498L197 279.193V293.287C197 297.516 202.642 302.331 205.463 304.211Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.733 261.575H297.206L293.482 239.376C278.248 236.909 253.874 249.242 244.733 254.175C237.421 258.121 241.687 260.752 244.733 261.575Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M304.654 261.575L301.268 239.376C335.46 236.557 351.71 249.947 360.173 254.175C366.944 257.558 364.349 260.517 362.204 261.575H304.654Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M262.545 304.563C262.545 314.565 254.78 322.5 245.41 322.5C236.04 322.5 228.275 314.565 228.275 304.563C228.275 294.561 236.04 286.626 245.41 286.626C254.78 286.626 262.545 294.561 262.545 304.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M414.886 304.563C414.886 314.565 407.121 322.5 397.751 322.5C388.381 322.5 380.616 314.565 380.616 304.563C380.616 294.561 388.381 286.626 397.751 286.626C407.121 286.626 414.886 294.561 414.886 304.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Cars);
export default __webpack_public_path__ + "static/media/2-cars.304a82e2082cea73f82a75acd13c822d.svg";
export { ForwardRef as ReactComponent };